class VariantOpener extends HTMLElement {
    constructor() {
        super();

        this.class = {
            scrollLock: 'lock',
        }

        this.dom = {
            main: this,
            variantValue: this.querySelector('[data-gtc-variant-value]')
        };
    }
    connectedCallback() {
        this.init();
    }

    attributeChangedCallback(name, oldValue, newValue) {
        this.updateStyle(this);
    }

    get isOpen() {
        return this.getAttribute("aria-expanded") === "true";
    }
    set isOpen(value) {
        document.removeEventListener("keydown", this.Keydown, false);

        if (value) {

            if (!gOverlayLoaded) {
                createGOverlay();
            }

            document.addEventListener("keydown", this.Keydown, false);
            window.addEventListener('resize', this.Debounce(() => {
                this.Resize();
            }, 300));

            document.body.classList.add(this.class.scrollLock);
        }
        else {
            document.removeEventListener("keydown", this.Keydown, false);
            window.removeEventListener('resize', this.Debounce(() => {
                this.Resize();
            }, 300));

            document.body.classList.remove(this.class.scrollLock);
        }

        this.setAttribute("aria-expanded", value ? "true" : "false");
    }

    init() {
        this.Click = this.Click.bind(this);
        this.Keydown = this.Keydown.bind(this);
        this.Resize = this.Resize.bind(this);
        this.Debounce = this.Debounce.bind(this);
        document.addEventListener('click', this.Click, false);
    }

    Keydown(event) {
        // If Esc key
        if (event.keyCode !== 27) return;
        this.isOpen = false;
    }

    Resize() {
        const mediaQuery = window.matchMedia('(max-width: 768px)');
        if (!mediaQuery.matches) {
            this.isOpen = false;
        }
    }

    Debounce = (func, delay) => {
        let timeoutId;
        return (...args) => {
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
            timeoutId = setTimeout(() => {
                func.apply(null, args);
            }, delay);
        };
    };


    Click(event) {
        const target = event.target;
        const mediaQuery = window.matchMedia('(max-width: 768px)');

        if (mediaQuery.matches) {

            if (target.hasAttribute('data-gtc-open')) {
                this.isOpen = true;
            }
            if (target.hasAttribute('data-gtc-close') || target.hasAttribute('data-variant-input')) {
                this.isOpen = false;
            }
        }

        if (target.hasAttribute('data-variant-input') && this.dom.variantValue) {
            this.dom.variantValue.innerText = target.value;
        }
    }

}
customElements.define('gtc-variant-opener', VariantOpener);